// Button.jsx
import React from 'react';

const Button = ({ label, isActive, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-2 font-semibold border border-gray-400 rounded-full text-sm ${
        isActive ? 'bg-pink-200 text-gray-800' : 'bg-white text-black'
      }`}
      // style={{ fontFamily: 'notsans, serif' }}
    >
      {label}
    </button>
  );
};

export default Button;
